import React, { useCallback, useEffect, useRef, useState } from 'react'
import { Template } from '../../Components/Template/template'
import { IoSave } from 'react-icons/io5'
import { Link, useParams } from 'react-router-dom'
import { FcNook } from 'react-icons/fc'
import {
    AlertType, classDivBackground, classInput, classInputDark, classLabel, classLabelDark, classBt, classDivBody, classbtAzul,
    classWeigthBt, barraVermelhoAzul, bgBlue, bgRed, classBorderLabelDark, focusRed, focusLabelRed, classbtColunasVermelho, classbtCinzaClaro,
    classUserCriarAtt, classDtCriarAtt, InputsRefs
} from '../../Utils/Types'
import { FeedbackMessage } from '../../Components/FeedbackMessage/feedback-message'
import { BsBoxArrowInLeft } from 'react-icons/bs'
import moment from 'moment'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { faClipboardList, faFolder } from '@fortawesome/free-solid-svg-icons'
import { Icone } from '../../Components/Icones/Index'
import { SerieService } from './SerieDocService'
import { AiOutlineClear } from 'react-icons/ai'
import { FaRegQuestionCircle } from 'react-icons/fa'
import { Tooltip } from 'react-tooltip'

type CampoObrigatorio = {
    campo: string,
    erro: boolean,
}

export const SerieDocNew = () => {

    // ----------------- TABS --------------------------------------------------------
    type Tab = {
        index: number,
        titulo: String,
        active: boolean,
        icon: IconProp,
    }

    const itabs: Tab[] = [
        { index: 0, titulo: 'Dados Principais', active: true, icon: faFolder },
        { index: 1, titulo: 'Auditoria', active: false, icon: faClipboardList },
    ]

    const [tabs, setTabs] = useState<Tab[]>(itabs)

    // ------------- CAMPOS OBRIGATORIOS ----------------------------------------------
    const fieldsMandatory: CampoObrigatorio[] = [
        { campo: 'num_doc', erro: false },  // Posição 0 do Array.    
        { campo: 'modelo', erro: false },   // Posição 1 do Array.    
        { campo: 'serie', erro: false },    // Posição 2 do Array.    
    ]

    const [CamposObrigatorios, setCamposObrigatorios] = useState<CampoObrigatorio[]>(fieldsMandatory)

    // ------------------ ATRIBUTOS ---------------------------------------------------
    const { idSerie } = useParams<string>()
    const [id, setId] = useState(0)
    const [numDoc, setNumDoc] = useState('')
    const [numDocCopia, setNumDocCopia] = useState('')
    const [modelo, setModelo] = useState('')
    const [serie, setSerie] = useState('')

    // ---------- ATRIBUTOS FEEDBACK -------------------------------------------------
    const [visible, setVisible] = useState(false)
    const [loading, setLoading] = useState(false)
    const [message, setMessage] = useState("")
    const [messageType, setMessageType] = useState<AlertType>("SUCCESS")

    // ---------- ATRIBUTOS AUDITORIA -------------------------------------------------
    const [userCriador, setUserCriador] = useState("")
    const [dtCriador, setDtCriador] = useState("")
    const [usertAtt, setUsertAtt] = useState("")
    const [dtAtt, setDtAtt] = useState("")

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- ATRIBUTOS E EFFECT --------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const getAttributes = async () => {
        setLoading(true)

        try {

            if (idSerie) {

                const serieAttributes = await SerieService.GetAttributes(idSerie)

                if (serieAttributes.data && idSerie) {
                    setId(serieAttributes.data.id)
                    setNumDoc(serieAttributes.data.num_doc.toString() || '')
                    setNumDocCopia(serieAttributes.data.num_doc.toString() || '')
                    setModelo(serieAttributes.data.modelo.toString() || '')
                    setSerie(serieAttributes.data.serie.toString() || '')

                    setUserCriador(serieAttributes.data.name_user_insert || '')
                    setUsertAtt(serieAttributes.data.name_user_last_update || '')

                    if (serieAttributes.data.dt_cadastro) {
                        const dataFormatadaCriacao = moment(serieAttributes.data.dt_cadastro).format('DD/MM/YYYY HH:mm')
                        setDtCriador(dataFormatadaCriacao)
                    }

                    if (serieAttributes.data.dt_last_update) {
                        const dataFormatadaAtt = moment(serieAttributes.data.dt_last_update).format('DD/MM/YYYY HH:mm')
                        setDtAtt(dataFormatadaAtt)
                    }
                }
            }

        } catch (error) {

            setVisible(true)
            setMessageType("DANGER")
            setMessage(`Não foi possível carregar os dados`)

        } finally {
            setLoading(false)
        }

    }

    useEffect(() => {
        getAttributes()
        inputFocus()
    }, [])

    const handleMouseUp = useCallback((e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        // Desfocar o link após o clique
        const target = e.target as HTMLElement
        if (target instanceof HTMLAnchorElement) {
            target.blur()
        }

        inputFocus()
    }, [])

    const handleChangeTab = async (tab: number) => {
        let newTabs = await tabs.map((item) => {
            if (item.index === tab) {
                itabs[item.index].active = true
            } else {
                itabs[item.index].active = false
            }
            return itabs[item.index]
        })
        setTabs(newTabs)
    }

    useEffect(() => {

        if (tabs[0].active) {
            inputFocus()
        }

    }, [tabs])

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- INPUTS --------------------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const numDocChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setNumDoc(e.target.value.replace(/[^0-9]/g, ''))
    }

    const modeloChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setModelo(e.target.value.replace(/[^0-9]/g, ''))
    }

    const serieChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSerie(e.target.value.replace(/[^0-9]/g, ''))
    }

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- SERIE DOCUMENTO FISCAL ----------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const novaSerie = () => {
        setId(0)
        setNumDoc('')
        setModelo('')
        setSerie('')

        setDtCriador('')
        setDtAtt('')
        setUserCriador('')
        setUsertAtt('')

        if (messageType === 'DANGER') {
            setVisible(false)
        }

        inputFocus()
        redefinirCampos()
    }

    const handleSaveSerie = async () => {

        if (messageType === 'DANGER') {
            setVisible(false)
        }
        setLoading(true)

        try {

            let serieDoc: any = {
                num_doc: numDoc,
                modelo: modelo,
                serie: serie,
            }

            if (id > 0) {
                serieDoc.id = id
            }

            const resp = await SerieService.Save(serieDoc)

            if (resp.error) {

                setVisible(true)
                setMessageType("DANGER")
                setMessage(resp.msg || ``)
                //checkDadosObrigatorios()

            } else {

                setVisible(true)
                setMessageType("SUCCESS")
                setId(resp.id || 0)
                setMessage(id > 0 ? `Dados da serie atualizados com sucesso` : resp.msg || ``)

                if (resp.dt_cadastro) {
                    const dataFormatadaCriacao = moment(resp.dt_cadastro).format('DD/MM/YYYY HH:mm')
                    setDtCriador(dataFormatadaCriacao)
                }

                if (resp.dt_last_update) {
                    const dataFormatadaAtt = moment(resp.dt_last_update).format('DD/MM/YYYY HH:mm')
                    setDtAtt(dataFormatadaAtt)
                }

                setNumDocCopia(resp.data.serie.num_doc)
                setUserCriador(resp.name_user_insert || '')
                setUsertAtt(resp.name_user_last_update || '')

                redefinirCampos()
            }

        } catch (error) {

            setVisible(true)
            setMessageType("DANGER")
            setMessage(id > 0 ? `Não foi possível atualizar os dados da série. Por favor, tente novamente` : `Não foi possível salvar os dados da série. Por favor, tente novamente`)

        } finally {
            const timer = setTimeout(() => {
                setLoading(false)
                inputFocus()
                clearTimeout(timer)
            }, 1200)
        }

    }

    const checkDadosObrigatorios = (): boolean => {

        if (parseInt(numDoc) <= 0) {
            let fieldsM: CampoObrigatorio[] = CamposObrigatorios.map((item) => {
                return { campo: item.campo, erro: item.campo === 'num_doc' ? true : false }
            }
            )
            setCamposObrigatorios(fieldsM)
            return true
        }

        if (parseInt(modelo) <= 0) {
            let fieldsM: CampoObrigatorio[] = CamposObrigatorios.map((item) => {
                return { campo: item.campo, erro: item.campo === 'modelo' ? true : false }
            }
            )
            setCamposObrigatorios(fieldsM)
            return true
        }

        if (parseInt(serie) <= 0) {
            let fieldsM: CampoObrigatorio[] = CamposObrigatorios.map((item) => {
                return { campo: item.campo, erro: item.campo === 'serie' ? true : false }
            }
            )
            setCamposObrigatorios(fieldsM)
            return true
        }

        return false
    }

    const redefinirCampos = async () => {

        let fieldsM: CampoObrigatorio[] = [
            { campo: 'num_doc', erro: false }, // Posição 0 do Array.    
            { campo: 'modelo', erro: false }, // Posição 1 do Array.    
            { campo: 'serie', erro: false }, // Posição 2 do Array.    
        ]

        setCamposObrigatorios(fieldsM)
    }

    const inputFocus = () => {
        const inputElement = document.getElementById("num_doc")
        inputElement?.focus()
    }

    const handleCloseMessage = () => {
        setVisible(false)
    }

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- FOCUS ABA 1 ---------------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const inputsRefs: InputsRefs = {
        numDoc: useRef(null),
        modelo: useRef(null),
        serie: useRef(null),

    }

    const handleTabPress = (event: any, inputKey: any) => {

        if (event.key === 'Tab' && tabs[0].active) {

            event.preventDefault() // Evita o comportamento padrão do 'Tab'

            // Obtenha as chaves dos elementos em ordem
            const keys = Object.keys(inputsRefs)

            // Encontre o índice do campo atual
            let currentIndex = keys.indexOf(inputKey)
            let nextIndex = currentIndex

            // Loop para encontrar o próximo campo habilitado e focável
            do {
                nextIndex = (nextIndex + 1) % keys.length;

                const nextEl = inputsRefs[keys[nextIndex]].current;

                if (!nextEl) continue;
                if (nextEl.disabled) continue;
                if (nextEl.tabIndex === -1) continue;
                if (nextEl.offsetParent === null) continue; // está invisível (ex: display: none)

                break;
            } while (nextIndex !== currentIndex);

            // Direcione o foco para o próximo campo habilitado e focável, se encontrado
            const nextRef = inputsRefs[keys[nextIndex]].current;
            if (nextRef && typeof nextRef.focus === 'function') {
                nextRef.focus();
            }
        }
    }

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- FOCUS ABA 2 ---------------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const handleTabPressNone = (event: any) => {

        if (event.key === 'Tab' && tabs[1].active) {
            event.preventDefault() // Evita o comportamento padrão do 'Tab'
        }
    }

    useEffect(() => {

        document.addEventListener('keydown', handleTabPressNone)

        return () => {

            document.removeEventListener('keydown', handleTabPressNone)
        }

    }, [tabs])

    const btNovoVisible = parseInt(idSerie || '') > 0 ? 'invisible hidden' : 'visible'

    return (
        <Template isLoading={loading}>

            <div className={`${classDivBackground}`}>

                <div id='div-body' className={`${classDivBody}`}>

                    <FeedbackMessage visible={visible} message={message} type={messageType} onCloseMessage={handleCloseMessage} />

                    <div className={`bg-white dark:bg-slate-600 border border-slate-300 dark:border-slate-800 shadow-md shadow-indigo-200 dark:shadow-slate-800 rounded-lg`}>

                        <div className={`h-[50px] flex items-center my-3 px-2`}>
                            <FcNook className={`text-slate-700 dark:text-slate-200 ml-2 mr-2`} size="25px" />
                            <span className={`text-base md:text-lg xl:text-2xl text-slate-700 dark:text-slate-200 break-all`}>{parseInt(idSerie || '') || id > 0 ? `Editar - Série - ${numDocCopia}` : `Cadastro - Série`}</span>
                        </div>

                        <div className={`w-full h-full`}>

                            <div className={`h-[60px] flex overflow-x-auto scrollable_horizontal border border-slate-200 dark:border-slate-700`}>
                                {tabs.map((item) => {
                                    return (

                                        <button tabIndex={-1} onClick={() => handleChangeTab(item.index)} key={item.index.toString()}
                                            className={`px-4 font-mono font-bold w-[180px]
                                                ${item.active ?
                                                    `hover:text-sky-500 text-sky-600 border border-b-[3px] border-l-0 border-t-0 border-r-slate-300 border-b-sky-600 dark:text-slate-200 dark:border-r-slate-700 dark:border-b-slate-300` :
                                                    `text-sky-600 dark:text-slate-300 bg-slate-100 hover:bg-slate-200 dark:bg-slate-700 dark:hover:bg-slate-600 border border-l-0 border-t-0 border-b-0 dark:border-slate-800`
                                                } `}>
                                            <div tabIndex={-1} className={`flex items-center`}>
                                                <span className={`mr-2`}><Icone icon={item.icon} /></span>
                                                <span className={`text-sm roboto whitespace-nowrap`}>{item.titulo}</span>
                                            </div>
                                        </button>


                                    )
                                })}

                            </div>

                            <div className={`${tabs[0].active ? 'block' : 'hidden'} relative`}>

                                <div className={`w-full h-auto grid gap-5 grid-cols-12 p-4`}>

                                    <div className={`relative col-span-12 space-y-1`}>
                                        <div className={`flex flex-row`}>
                                            <span className={`text-[14px] text-[#ACACAC] dark:text-slate-300 mr-2`}>Dados da Série do Doc. Fiscal</span>
                                            <FaRegQuestionCircle tabIndex={-1} data-tooltip-id={'tooltip-btn-question'} id={'btn-question'} className={`text-[#ACACAC] dark:text-slate-300 cursor-pointer`} size={18} />
                                            <Tooltip id={'tooltip-btn-question'} anchorSelect={'#btn-question'} positionStrategy="fixed" place='top' >
                                                <span >Os campos com borda <br /> vermelha são obrigatórios</span>
                                            </Tooltip>
                                        </div>
                                        <hr className={`border-0 h-px bg-slate-300 dark:bg-slate-700`} />
                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-4 md:col-span-3 xl:col-span-2`}>

                                        <div className={`${barraVermelhoAzul} ${numDoc != '' ? bgBlue : bgRed}`} />
                                        <input ref={inputsRefs.numDoc} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'numDoc')} id="num_doc" className={`${classInput} ${classInputDark} ${numDoc != '' ? '' : focusRed}`} type='text' inputMode='numeric' placeholder=" " autoComplete='off' value={numDoc} onChange={numDocChange} />
                                        <label htmlFor="num_doc" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} ${numDoc != '' ? '' : focusLabelRed}`}>Número Documento</label>
                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-4 md:col-span-3 xl:col-span-2`}>

                                        <div className={`${barraVermelhoAzul} ${modelo != '' ? bgBlue : bgRed}`} />
                                        <input ref={inputsRefs.modelo} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'modelo')} id="modelo" className={`${classInput} ${classInputDark} ${modelo != '' ? '' : focusRed}`} type='text' inputMode='numeric' placeholder=" " autoComplete='off' value={modelo} onChange={modeloChange} />
                                        <label htmlFor="modelo" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} ${modelo != '' ? '' : focusLabelRed}`}>Modelo</label>
                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-4 md:col-span-3 xl:col-span-2`}>

                                        <div className={`${barraVermelhoAzul} ${serie != '' ? bgBlue : bgRed}`} />
                                        <input ref={inputsRefs.serie} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'serie')} id="serie" className={`${classInput} ${classInputDark} ${serie != '' ? '' : focusRed}`} type='text' inputMode='numeric' placeholder=" " autoComplete='off' value={serie} onChange={serieChange} />
                                        <label htmlFor="serie" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} ${serie != '' ? '' : focusLabelRed}`}>Série</label>
                                    </div>

                                </div>

                                <div className={`flex flex-col space-y-3 m-4 sm:space-y-0 sm:space-x-4 sm:flex-row sm:justify-end`}>

                                    <Link tabIndex={-1} onMouseUp={handleMouseUp} to="/serieDoc" className={`${classbtColunasVermelho} ${classWeigthBt}`}>
                                        <BsBoxArrowInLeft size="20px" className={`mr-[5px]`} /> Voltar
                                    </Link>

                                    <button tabIndex={-1} onClick={novaSerie} className={`${classBt} ${btNovoVisible} ${classbtCinzaClaro} ${classWeigthBt}`}>
                                        <AiOutlineClear size="20px" className={`mr-[5px]`} /> Limpar Campos
                                    </button>

                                    <button tabIndex={-1} onClick={handleSaveSerie} className={`${classBt} ${classbtAzul} ${classWeigthBt}`} disabled={loading}>
                                        {!loading && <IoSave size="16px" className={`mr-[5px]`} />}
                                        {loading &&
                                            <div className={`h-[20px] w-[20px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-neutral-100 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                                                <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                                            </div>
                                        }
                                        {parseInt(idSerie || '0') > 0 || id != 0 ? !loading ? `Atualizar` : `Aguarde` : !loading ? `Salvar` : `Aguarde`}
                                    </button>

                                </div>
                            </div>

                            <div className={`${tabs[1].active ? 'block' : 'hidden'} relative h-[400px] sm:h-[200px]`}>

                                <div className={`w-full h-full flex flex-row p-4`}>

                                    <div className={`w-full grid grid-cols-12`}>

                                        <div className={`relative col-span-12 p-2 flex flex-col`}>
                                            <label htmlFor="userCriacaoSerie" className={`${classUserCriarAtt}`}>Criador</label>
                                            <span id="userCriacaoSerie" className={`${classDtCriarAtt}`}>{userCriador}</span>
                                        </div>

                                        <div className={`relative col-span-12 p-2 flex flex-col`}>
                                            <label htmlFor="dtCriacaoSerie" className={`${classUserCriarAtt}`}>Data de Criação</label>
                                            <span id="dtCriacaoSerie" className={`${classDtCriarAtt}`}>{dtCriador}</span>
                                        </div>

                                    </div>

                                    <div className={`w-full grid grid-cols-12`}>

                                        <div className={`relative col-span-12 p-2 flex flex-col`}>
                                            <label htmlFor="userAttSerie" className={`${classUserCriarAtt}`}>Atualizador</label>
                                            <span id="userAttSerie" className={`${classDtCriarAtt}`}>{usertAtt}</span>
                                        </div>

                                        <div className={`relative col-span-12 p-2 flex flex-col`}>
                                            <label htmlFor="dtAttSerie" className={`${classUserCriarAtt}`}>Data de Atualização</label>
                                            <span id="dtAttSerie" className={`${classDtCriarAtt}`}>{dtAtt}</span>
                                        </div>

                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>

                </div>

            </div>

        </Template>
    )
}